import { render, staticRenderFns } from "./PreviousName.vue?vue&type=template&id=3b9c5676"
import script from "./PreviousName.vue?vue&type=script&lang=js"
export * from "./PreviousName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports